import { render, staticRenderFns } from "./IssuetrackingCreate.vue?vue&type=template&id=1c478dea&"
import script from "./IssuetrackingCreate.vue?vue&type=script&lang=js&"
export * from "./IssuetrackingCreate.vue?vue&type=script&lang=js&"
import style0 from "./IssuetrackingCreate.vue?vue&type=style&index=0&id=1c478dea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports